import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { MobileNavBarTab } from "./mobile-nav-bar-tab";
import { useRoles } from "../../useRoles";

export const MobileNavBarTabs = ({ handleClick }) => {
  const { isAuthenticated } = useAuth0();
  const { isAdmin, isPartner, isLoading } = useRoles();

  if (isLoading) {
    return null;
  }

  return (
    <div className="mobile-nav-bar__tabs">
      <MobileNavBarTab
        path="/priser"
        label="Priser"
        handleClick={handleClick}
      />
      {isAuthenticated && (
        <>
          <MobileNavBarTab
            path="/dashbord"
            label="Dashbord"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/konto"
            label="Konto"
            handleClick={handleClick}
          />
          {isAdmin && (
            <MobileNavBarTab
              path="/admin"
              label="Admin"
              handleClick={handleClick}
            />
          )}
          {(isPartner || isAdmin) && (
            <MobileNavBarTab
              path="/partner"
              label="Partner"
              handleClick={handleClick}
            />
          )}
        </>
      )}
    </div>
  );
};
